import { Message } from "@apis:message/message";
import { Box, Tooltip } from "@mui/material";
import { groupReferences } from "@pages:app/talk/shared/utils";
import { isURL } from "@utils:general";
import { get } from "lodash";

const hoverableboxStyle = {
  position: "relative",
  display: "inline-block",
};

const superscriptStyle = {
  display: "inline-flex",
  justifyContent: "center",
  width: "13px",
  height: "13px",
  color: "#174AE4",
  backgroundColor: "#D1DBFA",
  borderRadius: "30%",
  fontSize: "75%",
  lineHeight: 1,
  verticalAlign: "super",
  marginLeft: "2px",
  marginRight: "2px",
  alignItems: "center",
};

interface HighlightNumbersInBracketsProps {
  text: string;
  references: Message["GET_ONE"]["Response"]["docs"];
}

export const HighlightNumbersInBrackets = ({
  text,
  references,
}: HighlightNumbersInBracketsProps) => {
  const groupedReferences = groupReferences(references);

  // Regular expression to identify numbers within square brackets (e.g., [1], [2])
  const regex = /\[(\d+)\]/g;

  // Splitting the text into an array where each element is either part of the original text
  // or a number within brackets
  const parts = text.split(/(\[\d+\])/);

  const tooltips: Record<number, string> = {};

  // Using the regex to find each occurrence of a number in brackets in the text
  let match: RegExpExecArray | null;
  while ((match = regex.exec(text)) !== null) {
    // refNumber is searchRanking in results
    const refNumber = parseInt(match[1], 10);

    tooltips[refNumber] = get(
      groupedReferences,
      `${refNumber - 1}.reference`,
      "",
    );
  }

  return (
    <Box component="span">
      <Box component="span">
        {parts.map((part, index) => {
          const match = part.match(/\[(\d+)\]/);

          if (match) {
            const number = parseInt(match[1], 10);
            const tooltipText = tooltips[number];
            const isLink = isURL(tooltipText);

            return (
              <Box key={index} sx={hoverableboxStyle} component="span">
                {isLink ? (
                  <Tooltip title={tooltipText}>
                    <Box
                      component="a"
                      href={tooltipText}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={superscriptStyle}
                    >
                      {number}
                    </Box>
                  </Tooltip>
                ) : (
                  <Tooltip title={tooltipText}>
                    <Box component="span" sx={superscriptStyle}>
                      {number}
                    </Box>
                  </Tooltip>
                )}
              </Box>
            );
          }
          return (
            <Box component="span" key={index}>
              {part}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
